const langtrans={
      dddfab:["等待方案报价案件","Waiting for quotation"],
      qssjj:["起始时间","Start time"],
      jjssjj:["结束时间","End time"],
      ajbh:["案件编号","Case number"],
      czx:["查询","Check"],
}
export default langtrans;


// WEBPACK FOOTER //
// ./src/components/fac/js/await.vue.trans.js